import FlashLib from "flashlib";

export default class WildSymbol extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.multiplier = null;

        this.init();
    }

    init() {
        this.multiplier = this.getChildByName('multiplier');
    }
}